<span class="tooltip-container">
  <span class="material-symbols-outlined tooltip-icon">info</span>
  <div
    class="tooltip-text"
    [style.width.px]="width"
    [style.height.px]="height"
    [style.top.px]="top"
    [style.left.px]="left"
  >
    <ng-content />
  </div>
</span>
